import { render, staticRenderFns } from "./card-bind.vue?vue&type=template&id=0128d07f&scoped=true&"
import script from "./card-bind.vue?vue&type=script&lang=js&"
export * from "./card-bind.vue?vue&type=script&lang=js&"
import style0 from "./card-bind.vue?vue&type=style&index=0&lang=less&"
import style1 from "./card-bind.vue?vue&type=style&index=1&id=0128d07f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0128d07f",
  null
  
)

export default component.exports